<template>
	<div class="main-content">
		<Breadcrumb class="bread">
			<BreadcrumbItem class="main-title">
				<span>{{ $options.filters.I18nColumn(step, 'Name') }}</span>
				<Icon type="md-arrow-dropright" color="dodgerblue" />
				<span style="font-size: 13px">{{ $t('開放時間') }}</span>
				<span style="font-size: 18px" class="ml-8"
					>{{ step.StartTime | DateTime }} - {{ step.EndTime | DateTime }}</span
				>
			</BreadcrumbItem>
		</Breadcrumb>
		<Card class="card-step">
			<div slot="title">
				<Icon type="ios-arrow-down"></Icon>
				<strong class="ml-8">{{ $t('上傳說明') }}</strong>
			</div>
			<div class="description" v-html="$options.filters.I18nColumn(step, 'Description')"></div>
		</Card>
		<br />
		<Card>
			<Row type="flex" justify="center" align="middle">
				<table border="1" height="50px" class="table-border" rules="rows">
					<tr>
						<th class="text-center pl-10" width="60%">{{ $t('應繳文件') }}</th>
						<th width="10%" type="flex" justify="center" align="middle" class="bor-left">
							{{ $t('操作') }}
						</th>
						<th width="30%" type="flex" justify="center" align="middle" class="bor-left">
							{{ $t('收登結果') }}
						</th>
					</tr>
				</table>
				<table
					v-for="(item, index) in freshmanUploadItems"
					:key="item.Id"
					border="1"
					class="table-border"
					rules="rows"
				>
					<tr style="height: 50px">
						<th class="text-left pl-10" width="60%">
							<label>{{ index + 1 }} {{ $options.filters.I18nColumn(item, 'Name') }}</label>
							<label style="color: red; vertical-align: middle; font-size: 18px">*</label>
							<br />
							<label v-if="item.Memo" style="color: lightslategray">{{
								$options.filters.I18nColumn(item, 'Memo')
							}}</label>
						</th>
						<th width="10%" type="flex" justify="center" align="middle" class="bor-left">
							<Upload
								:action="`api/FreshmanApplicationOfDocumentary/?uploadItem=${item.Id}&registerId=${registerId}`"
								:format="uploadFormat"
								:on-success="successUpload"
								:max-size="30720"
								:show-upload-list="false"
								:before-upload="beforeUpload"
								:on-error="errorUpload"
								:on-format-error="handleFormatError"
								:on-exceeded-size="handleMaxSize"
								class="upload-btn"
							>
								<Button :disabled="checkIsDisableEdit(item.Id)">
									<icon type="ios-cloud-upload-outline" size="22"></icon>
									{{ $t('上傳') }}
								</Button>
							</Upload>
						</th>
						<th
							width="30%"
							type="flex"
							justify="center"
							align="left"
							class="bor-left"
							:rowspan="documentList.filter(p => p.FreshmanUploadItem == item.Id).length + 1"
						>
							<strong
								v-if="getDocumentStatus(item.Id).Status === documentStatus.UnSubmitted"
								class="pl-10"
							>
								<span style="color: #5cadff">
									<Icon type="md-document" size="30" />
									{{ $t('尚未提交') }}
								</span>
							</strong>
							<strong
								v-else-if="getDocumentStatus(item.Id).Status === documentStatus.Checking"
								class="pl-10"
							>
								<span style="color: #5cadff">
									<Icon type="md-list-box" size="30" />
									{{ $t('文件審核中') }}
								</span>
							</strong>
							<strong
								v-else-if="getDocumentStatus(item.Id).Status === documentStatus.NotMatch"
								class="pl-10"
							>
								<span style="color: #ff3333">
									<Icon type="md-sad" size="30" />
									{{ $t('文件不符') }}
								</span>
								<br />
								<span class="pl-10">{{ getDocumentStatus(item.Id).Comment || '' }}</span>
							</strong>
							<strong
								v-else-if="getDocumentStatus(item.Id).Status === documentStatus.Finish"
								class="pl-10"
							>
								<span style="color: #5cadff">
									<Icon type="md-happy" size="30" />
									{{ $t('確認收件') }}
								</span>
							</strong>
							<strong v-else class="pl-10">
								<span style="color: #666666">{{ $t('尚未上傳') }}</span>
							</strong>
						</th>
					</tr>
					<tr
						rules="all"
						v-for="document in documentList.filter(p => p.FreshmanUploadItem == item.Id)"
						:key="document.FileId"
					>
						<td class="bor-top" width="60%" style="padding-left: 60px">
							<Row>
								<Col :xs="24" :sm="17" :md="17" :lg="18">
									<a target="_blank" :href="`api/File/${document.FileId}`">{{ document.FileName }}</a>
								</Col>
								<Col :xs="0" :sm="7" :md="7" :lg="6">{{ document.FileUpdate | DateTime }}</Col>
							</Row>
						</td>
						<td width="10%" type="flex" justify="center" align="middle" class="bor-left bor-top">
							<Button
								:disabled="checkIsDisableEdit(document.FreshmanUploadItem)"
								style="padding: 6px"
								@click="deleteModal(document.Id, document.FileId)"
							>
								<Icon type="ios-trash" size="22" />
							</Button>
						</td>
					</tr>
				</table>
			</Row>
			<div class="text-center" style="margin-top: 15px">
				<Row type="flex" justify="center" align="middle">
					<Col :xs="24" :sm="5" :md="3" :lg="3">
						<Button :disabled="!isCanSubmit" class="btn" type="primary" @click="isShowSaveModal = true">{{
							$t('確認完成')
						}}</Button>
					</Col>
					<Col :xs="24" :sm="5" :md="3" :lg="3">
						<Button class="btn" @click="goBack">{{ $t('返回') }}</Button>
					</Col>
				</Row>
			</div>
			<Spin size="large" fix v-show="isUploading">
				<Icon type="ios-loading" size="54" class="demo-spin-icon-load"></Icon>
				<div style="font-size: 40px">{{ $t('上傳中') }}</div>
			</Spin>
			<Spin size="large" fix v-show="isSaving">
				<Icon type="ios-loading" size="54" class="demo-spin-icon-load"></Icon>
				<div style="font-size: 25px">{{ $t('提交中請稍後') }}</div>
			</Spin>
		</Card>
		<Spin size="large" fix v-show="isLoading"></Spin>
		<Modal
			width="700"
			v-model="isShowDeleteModal"
			@on-ok="deleteOk(deleteDocumentaryId, deleteFileId)"
			:mask-closable="false"
			:ok-text="$t('確定')"
			:cancel-text="$t('取消')"
		>
			<span slot="header" style="font-size: 30px">
				<Icon type="md-warning" class="warning-icon" />
				<span>{{ $t('警告') }}</span>
			</span>
			<span style="font-size: 20px">{{ $t('刪除的檔案將無法復原！') }}</span>
		</Modal>
		<Modal
			width="700"
			v-model="isShowSaveModal"
			@on-ok="save(registerId)"
			:mask-closable="false"
			:ok-text="$t('確定')"
			:cancel-text="$t('取消')"
		>
			<span slot="header" style="font-size: 30px">
				<Icon type="md-warning" class="warning-icon" />
				<span>{{ $t('警告') }}</span>
			</span>
			<span style="font-size: 20px">{{ $t('確認文件上傳完成？提交後無法再修改！') }}</span>
		</Modal>
	</div>
</template>
<script>
import _ from 'lodash'
import { STEP } from '@/models/Step.ts'
import SystemSettingService from '@/services/SystemSettingService'
import ParaService from '@/services/ParaService'
import { FRESHMAN_APPLICATION } from '@/models/FreshmanApplication.ts'
import { DocumentStatus, EnrollFlowStep } from '@/enum/Enum.ts'
export default {
	data: function() {
		return {
			flowId: this.$route.params.flowId,
			planId: this.$route.params.planId,
			step: Object.assign({}, STEP),
			isLoading: true, //載入中
			isUploading: false, //上傳中
			isSaving: false, //提交中
			isShowDeleteModal: false, //刪除警告
			isShowSaveModal: false, //提交警告
			parameters: {},
			documentList: [
				{
					Id: null,
					RegisterId: null,
					FileId: null,
					FileName: null,
					FileSize: null,
					FileUpdate: null,
					FreshmanUploadItem: null,
					Status: null,
					Comment: null,
				},
			], //已上傳文件列表
			registerId: null,
			deleteDocumentaryId: null, //選定刪除ID
			deleteFileId: null, //選定刪除檔案ID
			uploadFormat: [], //可上傳格式
			formItem: Object.assign({}, FRESHMAN_APPLICATION),
			freshmanUploadItems: [],
			documentStatus: DocumentStatus,
			disableEditList: [DocumentStatus.Checking, DocumentStatus.Finish],
			canNotSubmitStatusList: [DocumentStatus.NotMatch],
			enrollFlowStep: EnrollFlowStep, //報到流程
		}
	},
	async created() {
		this.parameters = await ParaService.get(['p_FreshmanUploadItem'])
		let format = await SystemSettingService.get('Freshman.StundentUploadItemFormat')
		this.uploadFormat = format['Freshman.StundentUploadItemFormat'].split(',')
		await this.getApplication()
		await this.getSetupOfDocumentary()
	},
	async mounted() {
		await Promise.all([this.getStep(), this.getRegisterFlow(), this.getDocumentList()])
		this.isLoading = false
	},
	computed: {
		isCanSubmit() {
			if (!this.documentGroup) return false
			let isCanSave = true
			//檢查是否有尚未上傳文件的項目
			_.forEach(this.freshmanUploadItems, item => {
				if (this.documentList.filter(p => p.FreshmanUploadItem == item.Id).length == 0) {
					isCanSave = false
				}
			})
			//如果有項目尚未上傳則停用
			if (!isCanSave) return false

			let documentGroupValue = _.values(this.documentGroup)

			//如果有文件不符的項目則停用
			if (documentGroupValue.some(p => this.canNotSubmitStatusList.includes(p.Status))) return false

			//如果每個項目都是確認收件或文件審核中則停用
			if (documentGroupValue.every(p => this.disableEditList.includes(p.Status))) return false

			return true
		},
		documentGroup() {
			//依照應繳文件項目分組完取第一筆資料作為該文件項目的狀態
			return _.transform(
				_.groupBy(this.documentList, document => document.FreshmanUploadItem),
				(result, value, key) => (result[key] = value[0]),
			)
		},
	},
	methods: {
		async getApplication() {
			try {
				let response = await this.$http.get(`api/FreshmanApplication/Application/${this.planId}`)
				this.formItem = Object.assign(this.formItem, response.data)
			} catch (err) {
				this.$Message.error(this.$t('查無資料'))
			}
		},
		async getSetupOfDocumentary() {
			try {
				let response = await this.$http.get(`api/SetupOfDocumentary/GetEnable`, {
					params: {
						typeOfIdentity: this.formItem.TypeOfIdentity,
						graduatedSchoolType: this.formItem.GraduatedSchoolType,
					},
				})
				this.freshmanUploadItems = response.data
			} catch (err) {
				this.$Message.error(this.$t('查無資料'))
			}
		},
		//取得階段資料
		async getStep() {
			try {
				let response = await this.$http.get(`api/FreshmanApplicationOfDocumentary/${this.flowId}`)
				this.step = response.data
			} catch (err) {
				this.$Message.error(this.$t('查無資料'))
			}
		},
		//取得新生階段資料
		async getRegisterFlow() {
			try {
				let response = await this.$http.get(
					`api/FreshmanRegisterFlow/Flow/${this.planId}/${this.enrollFlowStep.UploadDocument}/me`,
				)
				//設定registerId，給上傳檔案action使用，以及提交使用
				this.registerId = response.data.RegisterId
			} catch (err) {
				this.$Message.error(this.$t('查無資料'))
			}
		},
		//取得新生已上傳檔案列表
		async getDocumentList() {
			try {
				let response = await this.$http.get(`api/FreshmanApplicationOfDocumentary/GetList/${this.planId}`)
				this.documentList = response.data
			} catch (err) {
				this.$Message.error(this.$t('尚未上傳檔案'))
			}
		},
		//取得文件收登結果
		getDocumentStatus(phsiName) {
			return this.documentGroup[phsiName] || { Status: null, Comment: null }
		},
		//檢查是否停用上傳或刪除
		checkIsDisableEdit(phsiName) {
			//狀態為審核中或確認收件則返回True
			var disable = false
			let documentStatus = this.documentGroup[phsiName]
			if (documentStatus) {
				disable = _.includes(this.disableEditList, documentStatus.Status)
			}
			return disable
		},
		//顯示刪除檔案警告視窗
		deleteModal(documentaryId, fileId) {
			//設定要刪除資料
			this.deleteDocumentaryId = documentaryId
			this.deleteFileId = fileId
			this.isShowDeleteModal = true
		},
		//刪除檔案警告視窗點擊確認
		deleteOk(documentaryId, fileId) {
			this.deleteDocument(documentaryId, fileId)
		},
		//刪除檔案
		async deleteDocument(documentaryId, fileId) {
			try {
				let response = await this.$http.delete(
					`api/FreshmanApplicationOfDocumentary/Delete/${documentaryId}/${fileId}`,
				)
				//取得刪除檔案在原檔案列表的資料
				let document = this.documentList.find(p => p.FileId === response.data)
				//取得刪除檔案在原檔案列表的位置
				let index = this.documentList.indexOf(document)
				//將已刪除檔案在原檔案列表中移除
				this.documentList.splice(index, 1)
			} catch (err) {
				this.$Message.error(this.$t('刪除失敗'))
			}
		},
		//提交
		async save(registerId) {
			if (_.values(this.documentGroup).some(p => this.canNotSubmitStatusList.includes(p.Status))) {
				this.$Message.error(this.$t('尚有文件未上傳，請重新確認！'))
				return
			}

			try {
				this.isSaving = true
				//更改註冊階段
				let response = await this.$http.post(
					`api/FreshmanRegisterFlow/Save/${registerId}/${this.enrollFlowStep.UploadDocument}/me`,
				)
				//更新學生文件狀態
				await this.$http.put(`api/FreshmanApplication/UpdateDocumentStatus/${this.formItem.Id}`)
				//更新文件狀態
				await this.$http.put(`api/FreshmanApplicationOfDocumentary/UpdateStatus/${registerId}`)
				_.forEach(this.documentGroup, document => {
					if (document.Status != this.documentStatus.Finish) document.Status = this.documentStatus.Checking
				})
			} catch (err) {
				this.$Message.error(this.$t('提交失敗'))
			} finally {
				this.isSaving = false
			}
		},
		//檔案上傳之前顯示上傳Spin
		beforeUpload() {
			this.isUploading = true
		},
		//檔案上傳失敗
		errorUpload() {
			this.$Message.error(this.$t('上傳失敗'))
			this.isUploading = false
		},
		//成功上傳
		successUpload(documentData) {
			//將成功上傳檔案加入原檔案列表中且預設為尚未提交
			documentData.Status = this.documentStatus.UnSubmitted
			this.documentList.push(documentData)
			this.documentGroup[documentData.FreshmanUploadItem].Status = this.documentStatus.UnSubmitted
			this.isUploading = false
		},
		//上傳格式錯誤
		handleFormatError(file) {
			this.$Notice.warning({
				title: this.$t('格式錯誤'),
				desc: this.$t('請上傳格式:{0}', [this.uploadFormat]),
			})
			this.isUploading = false
		},
		//上傳容量錯誤
		handleMaxSize(file) {
			this.$Notice.warning({
				title: this.$t('容量錯誤'),
				desc: this.$t('容量僅限30MB以內'),
			})
			this.isUploading = false
		},
		//返回
		goBack() {
			this.$router.go(-1)
		},
	},
}
</script>
<style lang="scss" scoped>
.description {
	margin: 0 10px 0 25px;
}
.ivu-col {
	padding-right: 10px;
	margin-bottom: 10px;
	margin-top: 10px;
}
.btn {
	width: 100%;
}
.demo-spin-icon-load {
	animation: ani-demo-spin 1s linear infinite;
}
.upload-btn {
	margin: 8px 0px 8px 0px;
}
.bor-left {
	border-left: 1px solid #e8eaec;
}
.bor-top {
	border-top: 1px solid #e8eaec;
}
.warning-icon {
	color: #ff9900;
}
.table-border {
	border-color: #e8eaec;
	border-style: solid;
	width: 100%;
	word-break: break-all;
}
</style>
